import React, { useContext } from "react";
import { APP_PAGE, actions } from "../../hooks/useAppState";
import useT from "../../hooks/useT";
import Button from "../../components/Button";
import { AppStateContext } from "../App";

export interface AppLayoutHeaderLeftCancelProps {
  lang?: string;
  label?: string;
}

export default function AppLayoutHeaderLeftCancel({
  lang,
  label = "general.buttons.cancel.label"
}: AppLayoutHeaderLeftCancelProps) {
  const [appState, doAppStateAction] = useContext(AppStateContext);
  const { t } = useT();
  const lng = lang || appState.language;
  return (
    <Button
      icon="arrow-left"
      label={t(label, { lng })}
      className="button-role-cancel"
      onClick={(event: React.MouseEvent) => {
        event.preventDefault();
        doAppStateAction(actions.setPage(APP_PAGE.ACTIONS));
      }}
    />
  );
}
